var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { Savable } from '@/common/mixins/Savable';
import { Validatable } from '@/common/mixins/Validatable';
import { sanitize } from '@/common/utils/stringUtilities';
var TextAreaControl = /** @class */ (function (_super) {
    __extends(TextAreaControl, _super);
    function TextAreaControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TextAreaControl.prototype, "defaultRules", {
        get: function () {
            return { required: this.required, maxlength: this.maxLength };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextAreaControl.prototype, "mergedRules", {
        get: function () {
            return this.rules ? Object.assign(this.defaultRules, this.rules) : this.defaultRules;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextAreaControl.prototype, "isDisabled", {
        get: function () {
            return Boolean(this.$attrs.disabled) || this.isReadOnly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextAreaControl.prototype, "ariaLabelledBy", {
        get: function () {
            return this.labelledBy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextAreaControl.prototype, "placeholder", {
        get: function () {
            if (this.isDisabled) {
                return '';
            }
            var placeholderString = "";
            if (this.placeholderKey) {
                placeholderString = this.$t(this.placeholderKey).toString();
            }
            else {
                placeholderString = this.$t("Placeholder.TextArea").toString();
            }
            if (this.showMaxLengthInPlaceholder && this.maxLength > 0)
                placeholderString += " " + this.$t("BudgetaryEstimate.Delegation.Maximum").toString().toLowerCase() + " " + this.$options.filters.formatNumber(this.maxLength) + " " + this.$t("Chars").toString();
            return placeholderString;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextAreaControl.prototype, "modifiedValue", {
        get: function () {
            return this.value;
        },
        set: function (modifiedStr) {
            this.$emit("input", modifiedStr);
        },
        enumerable: false,
        configurable: true
    });
    TextAreaControl.prototype.onBlur = function () {
        if (!this.isReadOnly && !this.isDisabled) {
            this.modifiedValue = sanitize(this.modifiedValue);
            this.$emit('blur');
            this.blur();
        }
    };
    var _a;
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TextAreaControl.prototype, "id", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TextAreaControl.prototype, "value", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TextAreaControl.prototype, "placeholderKey", void 0);
    __decorate([
        Prop({ type: Number, default: 10 }),
        __metadata("design:type", Number)
    ], TextAreaControl.prototype, "rows", void 0);
    __decorate([
        Prop({ type: Number, default: 4000 }),
        __metadata("design:type", Number)
    ], TextAreaControl.prototype, "maxLength", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], TextAreaControl.prototype, "required", void 0);
    __decorate([
        Prop(Object),
        __metadata("design:type", typeof (_a = typeof Object !== "undefined" && Object) === "function" ? _a : Object)
    ], TextAreaControl.prototype, "rules", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TextAreaControl.prototype, "labelledBy", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextAreaControl.prototype, "noResize", void 0);
    __decorate([
        Prop({ type: Boolean, default: true }),
        __metadata("design:type", Boolean)
    ], TextAreaControl.prototype, "showMaxLengthInPlaceholder", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], TextAreaControl.prototype, "alignRight", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], TextAreaControl.prototype, "showTooltip", void 0);
    TextAreaControl = __decorate([
        Component({
            name: 'TextAreaControl',
            components: {
                ValidationProvider: ValidationProvider
            },
            inheritAttrs: false
        })
    ], TextAreaControl);
    return TextAreaControl;
}(Mixins(Savable, Validatable)));
export default TextAreaControl;
